import api from './client';

export function getLegalMetadata() {
  return api.get('/legal/metadata').then((response) => response.data);
}
